import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { SESSION_PAGE_SIZE_OPTIONS } from '../../services/model/trace-service';

/**
 * Pager for the session list.
 *
 * The backend cursor is a DynamoDB LastEvaluatedKey, which only moves forward -
 * there is no total count and no way to jump to an arbitrary page. So this is a
 * prev/next pager over a cursor history held by the caller, showing the current
 * page number rather than "page 3 of 12".
 */
export default function SessionPager({
    pageNumber,
    rangeStart,
    rangeEnd,
    pageSize,
    onPageSizeChange,
    hasPrevious,
    hasNext,
    onPrevious,
    onNext,
    loading,
}) {
    const disabled = loading;

    return (
        <div className="border-t border-gray-200 bg-white px-3 py-2">
            <div className="flex items-center justify-between gap-2">
                <span className="text-[11px] tabular-nums text-gray-500">
                    {rangeEnd > 0 ? `${rangeStart}–${rangeEnd}` : 'No sessions'}
                </span>

                <div className="flex items-center gap-1">
                    <button
                        type="button"
                        onClick={onPrevious}
                        disabled={disabled || !hasPrevious}
                        title="Previous page"
                        className="rounded border border-gray-300 bg-white p-1 text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                        <HiChevronLeft size={14} />
                    </button>

                    <span className="min-w-[1.5rem] text-center text-[11px] tabular-nums text-gray-600">
                        {pageNumber}
                    </span>

                    <button
                        type="button"
                        onClick={onNext}
                        disabled={disabled || !hasNext}
                        title="Next page"
                        className="rounded border border-gray-300 bg-white p-1 text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                        <HiChevronRight size={14} />
                    </button>
                </div>
            </div>

            <div className="mt-1.5 flex items-center gap-1.5">
                <label htmlFor="trace-page-size" className="text-[11px] text-gray-500">
                    Per page
                </label>
                <select
                    id="trace-page-size"
                    value={pageSize}
                    disabled={disabled}
                    onChange={event => onPageSizeChange(Number(event.target.value))}
                    className="rounded border border-gray-300 bg-white py-0.5 pl-1.5 pr-6 text-[11px] text-gray-700 focus:border-indigo-500 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-60"
                >
                    {SESSION_PAGE_SIZE_OPTIONS.map(option => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}
